module.exports = __webpack_public_path__ + "img/build2.7473c246.png";